// extracted by mini-css-extract-plugin
module.exports = {"Root":"upload-client-avatar_Root__WjROY","AvatarContainer":"upload-client-avatar_AvatarContainer__MROf9","Cross":"upload-client-avatar_Cross__9YGXp"};